import IconTriangleWarning from '@mnd-frontend/icons/components/TriangleWarning';
import { Dialog } from '@mnd-frontend/ui/publish/components';
import { useContext } from 'react';
import { SystemDialogContext } from '../../../../contexts/SystemDialogContext';

const SystemDialog = () => {
  const {
    state: { show, labelConfirm, onConfirm, title, message },
    close,
  } = useContext(SystemDialogContext);

  return (
    <Dialog
      open={show}
      onClose={close}
      icon={<IconTriangleWarning $size="sm" $color="colorIconsWarning" />}
      headline={title}
      description={message || ''}
      confirmAction={{
        onClick: onConfirm,
        text: labelConfirm,
      }}
    />
  );
};

export default SystemDialog;
